// extracted by mini-css-extract-plugin
export default {"container":"pY-z","title":"qY-z","link":"rY-z"};